import { ItemVM } from 'shell/view-models/item';

export enum StateCommunication {
  DaStampare = '30',
  StampaEffettuata = '31',
  SpeditaEmail = '32',
}

export const CodeStateCommunication: Array<ItemVM> = [
  {
    id: StateCommunication.DaStampare,
    value: 'Da stampare',
  },
  {
    id: StateCommunication.StampaEffettuata,
    value: 'Stampa effettuata',
  },
  {
    id: StateCommunication.SpeditaEmail,
    value: 'Spedita mail',
  },
];

export const nameCodeStateCommunication = (id: string): string => {
  return CodeStateCommunication.find((el) => el.id === id)?.value || '';
};
